<template>
  <div class="l-empty" :style="{margin: margin + 'px 0'}">
    <img :src="imgSrc" alt="" :style="{width: imgWidth + 'px'}">
    <div class="tip" >{{ text }}</div>
    <div v-if="isSearch" class="search-tip">{{ $t('table.noSearchResult') }}</div>
    <div v-if="desc" class="search-tip">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'PtIndex',
  props: {
    text: {
      type: String,
      default() {
        // 使用 $t 获取国际化默认值
        return this.$t('noDataEmpty');
      }
    },
    imgSrc: {
      type: String,
      default: require('@/assets/img/bj_zanwu_2.png')
    },
    imgWidth: {
      type: Number,
      default: 284
    },
    fontSize: {
      type: Number,
      default: 14
    },
    margin: {
      type: Number,
      default: 186
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.l-empty {
  text-align: center;
  img {
    height: auto;
  }
  .tip {
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-top: -34px;
    color: #0D2340;

  }
  .search-tip {
    color: #0D2340;
    // margin-top: 30px;
  }
}
</style>
